// removed by extract-text-webpack-plugin
module.exports = {"primary":"_3Jrhb","secondary":"_19bnf","content":"_1oMGG","icon":"_3xk1z","ghost":"_3wyXl"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@snapask/common-components/styles/buttonTheme/gray.scss
// module id = 220
// module chunks = 34